import { loggerService } from './logger.service';

const { log, logGroup } = loggerService;

export { loggerService, log, logGroup };
